import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/index/ic5.webp")